import React from 'react'
import { Button } from 'antd'
import { DragSortingTable } from 'modules/atoms/drag-sorting-table'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { headers } from './headers'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import styles from './styles.module.scss'

interface ICounterpartsTable {
  form: any
  data: any[]
  onAddUser: () => void
  setCounterparts: any
  onRemoveUser: (token: string) => void
  t: any
}

export const CounterpartsTable: React.FC<ICounterpartsTable> = ({
  form,
  data = [],
  setCounterparts,
  onAddUser,
  onRemoveUser,
  t
}) => {
  const ordered_signers = form.getFieldValue('ordered_signers')
  return (
    <div className={`rankmiSignature-counterpartsTable ${styles.container}`}>
      <div className={styles.buttonContainer}>
        <Button className={styles.addButton} onClick={() => onAddUser?.()}>
          <FontAwesomeIcon icon={faPlus as IconProp} />
          <span>
            {t('signature.newDocument.stepsForm.couterpartsInput.addText')}
          </span>
        </Button>
      </div>
      <DragSortingTable
        headers={headers(onRemoveUser, t, ordered_signers)}
        form={form}
        data={data}
        setSigners={setCounterparts}
      />
    </div>
  )
}
